import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import WashCreateUpdate, {
  WashCreateUpdateHandle,
  WashCreateUpdateProps,
} from "./WashCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: WashCreateUpdateProps;
}

export default function WashCreateUpdateModal({ createUpdateProps, ...modalProps }: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.washId });
  const formWrapperRef = useRef<WashCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} wash
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <WashCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
